import { useState } from 'react';

/**
 * Creates a `makeTransform` function that leverages the State API for holding a "display" version
 * of the uses's input value. The unseen stored value is actually a trimmed version of the input
 * allowing the validation to apply to a spaces only input as if it were empty, and thus invalid.
 */
function useTrimField() {
  const [display, setDisplay] = useState({});

  const makeTransform = (name) => ({
    output: (value) => {
      setDisplay(prev => ({ ...prev, [name]: value }));
      return value?.trim();
    },
    input: (value) => display[name] ?? value,
  });

  return makeTransform;
};

export default useTrimField;
